import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

export const reactPlugin = new ReactPlugin();

const connectionString =
  process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;

let appInsights = null;

export function initAppInsights() {
  if (!connectionString || typeof window === 'undefined') return null;

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      extensions: [reactPlugin],
      enableAutoRouteTracking: true,
      disableFetchTracking: false,
      enableCorsCorrelation: false,
      disableCookiesUsage: true,
      loggingLevelConsole: 0,
    },
  });

  appInsights.loadAppInsights();
  appInsights.trackPageView();
  return appInsights;
}

export { appInsights };
